"use strict";

var PropTypes = require("prop-types");

var BaseSearchPaging = require("./BaseSearchPaging");

class EventSearchPaging extends React.Component {
	handlePageChange(pageNumber) {
		var $searchResultsComponent = $(ReactDOM.findDOMNode(this)).closest("[data-component='eventSearchResults']");
		window.EventSearchActions.performEventSearch($searchResultsComponent.attr("id"), pageNumber);
	}

	render() {
		return (
			<BaseSearchPaging
				{...this.props}
				thisArg={this}
				className="event-search-paging"
				previousPageSelector="[data-component='eventSearchResults.populated.paging.previousPage']"
				nextPageSelector="[data-component='eventSearchResults.populated.paging.nextPage']"
				onPageChange={this.handlePageChange.bind(this)}
				dataReactComponentName="EventSearchPaging"
				dataReactComponentCategory="EventSearchPagingComponents"
			/>
		);
	}
}

EventSearchPaging.propTypes = {
	currentPageNumber: PropTypes.number,
	dataChildOf: PropTypes.string,
	dataComponentId: PropTypes.string,
	dataNestedId: PropTypes.string,
	dataRepeatedId: PropTypes.string,
	includeFirstPageNumber: PropTypes.bool,
	includeLastPageNumber: PropTypes.bool,
	isCustomTheme: PropTypes.bool,
	isDesignMode: PropTypes.bool,
	numberPagesToShow: PropTypes.number,
	pageSize: PropTypes.number,
	theme: PropTypes.string,
	totalCount: PropTypes.number
};

module.exports = EventSearchPaging;
